<template>
  <Modal
    :id="'cmp-catalog-tracks-advanced_search'"
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('tracks_advanced_search')}}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'artist'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="artist"
            isModel
            :placeholder="$t('artist')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'title'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="title"
            isModel
            :placeholder="$t('title')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'version'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="version"
            isModel
            :placeholder="$t('version')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :id="'track_type'"
            class="m2"
            :options="advancedSearchData.tracksTypeTV || []"
            :selected="
              advancedSearchData.tracksTypeTV.find((t) => t.value == track_type)
            "
            :placeholder="$t('type')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('track_type', e)"
            :listHeight="250"
          ></Dropdown>
          <Dropdown
            :id="'digital_right'"
            class="m2"
            :options="advancedSearchData.digitalRightTpyesTV"
            :selected="
              advancedSearchData.digitalRightTpyesTV.find(
                (x) => x.value == digital_right
              )
            "
            :placeholder="$t('digital_rights')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('digital_right', e)"
          ></Dropdown>
          <Dropdown
            :id="'genres'"
            class="m2"
            :options="advancedSearchData.genresTV"
            :selected="
              advancedSearchData.genresTV.filter((e) =>
                ((genres && genres.split(',')) || []).includes(e.value)
              )
            "
            :placeholder="$t('genres')"
            multiple
            allnone
            box
            @selectedChange="(e) => onGenreSelected(e)"
            :listHeight="252"
          ></Dropdown>
          <div class="checkbox-container">
            <!-- <div class="dt-checkbox-control" @click.stop="e => toggleSearch('isrc_error')"> -->
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  name="isrc_error"
                  id="isrc_error"
                  :checked="isrc_error == 1"
                  @change="(e) => onCheckboxChange('isrc_error', e)"
                />
                <!-- :checked="activatedSearches.has('isrc_error')"
                  @change="e => onSearchActivated('isrc_error', e)" -->
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">{{$t('isrc_error')}}</div>
            </div>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  name="missing_main_product"
                  :id="'missing_main_product'"
                  :checked="missing_main_product == 1"
                  @change="(e) => onCheckboxChange('missing_main_product', e)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">{{$t('missing_main_product')}}</div>
            </div>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  name="product_track_mismatch"
                  :id="'product_track_mismatch'"
                  :checked="product_track_mismatch == 1"
                  @change="(e) => onCheckboxChange('product_track_mismatch', e)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">
                {{$t('product_track_mismatch_search')}}
              </div>
            </div>
          </div>
          <Dropdown
            :id="'licence_account'"
            class="m2"
            :options="advancedSearchData.licensorsTV"
            :selected="
              advancedSearchData.licensorsTV.find(
                (x) => x.value == licence_account
              )
            "
            :placeholder="$t('licence_account')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('licence_account', e)"
          ></Dropdown>
          <Dropdown
            :id="'main_label'"
            class="m2"
            :options="advancedSearchData.labelsTV"
            :selected="
              advancedSearchData.labelsTV.find((x) => x.value == main_label)
            "
            :placeholder="$t('main_label')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('main_label', e)"
          ></Dropdown>
          <Dropdown
            :id="'any_label'"
            class="m2"
            :options="advancedSearchData.labelsTV"
            :selected="
              advancedSearchData.labelsTV.find((x) => x.value == any_label)
            "
            :placeholder="$t('any_label')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('any_label', e)"
          ></Dropdown>
          <div class="checkbox-container">
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  name="playtime_missing"
                  :id="'playtime_missing'"
                  :checked="playtime_missing == 1"
                  @change="(e) => onCheckboxChange('playtime_missing', e)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">{{$t('playtime_missing')}}</div>
            </div>
          </div>

          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'composer'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="composer"
                isModel
                :placeholder="$t('composer')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('composer'),
                }"
                @click="(e) => onSearchOmittedToggle('composer')"
              >
                <div class="dt-icon-container">
                  <img
                    :src="
                      isOmitted('composer')
                        ? 'static/icons/omit-accent.svg'
                        : 'static/icons/omit.svg'
                    "
                    class="dt-icon s1 v7"
                    :alt="$t('omit')"
                    :title="$t('omit')"
                  />
                </div>
                <label class="omit-toggler--label">{{$t('missing')}}</label>
              </div>
            </div>
          </div>
          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'writer'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="writer"
                isModel
                :placeholder="$t('writer')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('writer'),
                }"
                @click="(e) => onSearchOmittedToggle('writer')"
              >
                <div class="dt-icon-container">
                  <img
                    :src="
                      isOmitted('writer')
                        ? 'static/icons/omit-accent.svg'
                        : 'static/icons/omit.svg'
                    "
                    class="dt-icon s1 v7"
                    :alt="$t('omit')"
                    :title="$t('omit')"
                  />
                </div>
                <label class="omit-toggler--label">{{$t('missing')}}</label>
              </div>
            </div>
          </div>
          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'publisher'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="publisher"
                isModel
                :placeholder="$t('publisher')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('publisher'),
                }"
                @click="(e) => onSearchOmittedToggle('publisher')"
              >
                <div class="dt-icon-container">
                  <img
                    :src="
                      isOmitted('publisher')
                        ? 'static/icons/omit-accent.svg'
                        : 'static/icons/omit.svg'
                    "
                    class="dt-icon s1 v7"
                    :alt="$t('omit')"
                    :title="$t('omit')"
                  />
                </div>
                <label class="omit-toggler--label">{{$t('missing')}}</label>
              </div>
            </div>
          </div>
          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'producer'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="producer"
                isModel
                :placeholder="$t('producer')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('producer'),
                }"
                @click="(e) => onSearchOmittedToggle('producer')"
              >
                <div class="dt-icon-container">
                  <img
                    :src="
                      isOmitted('producer')
                        ? 'static/icons/omit-accent.svg'
                        : 'static/icons/omit.svg'
                    "
                    class="dt-icon s1 v7"
                    :alt="$t('omit')"
                    :title="$t('omit')"
                  />
                </div>
                <label class="omit-toggler--label">{{$t('missing')}}</label>
              </div>
            </div>
          </div>
          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'arranger'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="arranger"
                isModel
                :placeholder="$t('arranger')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('arranger'),
                }"
                @click="(e) => onSearchOmittedToggle('arranger')"
              >
                <div class="dt-icon-container">
                  <img
                    :src="
                      isOmitted('arranger')
                        ? 'static/icons/omit-accent.svg'
                        : 'static/icons/omit.svg'
                    "
                    class="dt-icon s1 v7"
                    :alt="$t('omit')"
                    :title="$t('omit')"
                  />
                </div>
                <label class="omit-toggler--label">{{$t('missing')}}</label>
              </div>
            </div>
          </div>
          <Dropdown
            :id="'royalty_period'"
            class="m2"
            :options="advancedSearchData.royaltyPeriodsTV"
            :selected="
              advancedSearchData.royaltyPeriodsTV.find(
                (x) => x.value == royalty_period
              )
            "
            :placeholder="$t('royalty_period')"
            box
            @selectedChange="(e) => onDropdownChange('royalty_period', e)"
          ></Dropdown>
          <Dropdown
            :id="'invoice_project'"
            class="m2"
            :options="advancedSearchData.royaltyInvoiceProjectTV"
            :selected="
              advancedSearchData.royaltyInvoiceProjectTV.find(
                (x) => x.value == invoice_project
              )
            "
            :placeholder="$t('royalty_invoice_project')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('invoice_project', e)"
          ></Dropdown>
          <div class="checkbox-container">
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  name="no_contract"
                  :id="'no_contract'"
                  :checked="no_contract == 1"
                  @change="(e) => onCheckboxChange('no_contract', e)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">{{$t('no_contract')}}</div>
            </div>
          </div>
          <Dropdown
            :id="'royalty-account'"
            class="m2"
            :options="advancedSearchData.royaltyAccountsTV"
            :selected="
              advancedSearchData.royaltyAccountsTV.find(
                (x) => x.value == royalty_account
              )
            "
            :placeholder="$t('royalty_account')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('royalty_account', e)"
          ></Dropdown>
          <div class="row-control">
            <Dropdown
              :id="'metadata_field1'"
              class="m2"
              :options="advancedSearchData.metaDataTV"
              :placeholder="$t('metadata') + ' 1'"
              :selected="
                advancedSearchData.metaDataTV.find(
                  (x) => x.value == metadata_field1
                )
              "
              box
              deselect
              @selectedChange="(e) => onDropdownChange('metadata_field1', e)"
            ></Dropdown>
            <div class="search--input">
              <TextField
                :id="'metadata_value1'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="metadata_value1"
                isModel
                :placeholder="$t('metadata') + ' ' + $t('value') + ' 1'"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>
          <div class="row-control">
            <Dropdown
              :id="'metadata_field2'"
              class="m2"
              :options="advancedSearchData.metaDataTV"
              :selected="
                advancedSearchData.metaDataTV.find(
                  (x) => x.value == metadata_field2
                )
              "
              :placeholder="$t('metadata') + ' 2'"
              box
              deselect
              @selectedChange="(e) => onDropdownChange('metadata_field2', e)"
            ></Dropdown>
            <div class="search--input">
              <TextField
                :id="'metadata_value2'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="metadata_value2"
                isModel
                :placeholder="$t('metadata') + ' ' + $t('value') + ' 2'"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>
          <div class="row-control">
            <Dropdown
              :id="'metadata_field3'"
              class="m2"
              :options="advancedSearchData.metaDataTV"
              :selected="
                advancedSearchData.metaDataTV.find(
                  (x) => x.value == metadata_field3
                )
              "
              :placeholder="$t('metadata') + ' 3'"
              box
              deselect
              @selectedChange="(e) => onDropdownChange('metadata_field3', e)"
            ></Dropdown>
            <div class="search--input">
              <TextField
                :id="'metadata_value3'"
                class="m1"
                v-bind="textFieldConfig"
                v-model="metadata_value3"
                isModel
                :placeholder="$t('metadata') + ' ' + $t('value') + ' 3'"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
          </div>

          <div class="date-control ut-flex">
            <TextField
              type="date"
              :id="'income_start'"
              class="m1"
              :placeholder="$t('start_date')"
              :value="income_start"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
            <TextField
              type="date"
              :id="'income_end'"
              class="m1"
              :placeholder="$t('end_date')"
              :value="income_end"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
          </div>

          <TextField
            :id="'track_grid'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="track_grid"
            isModel
            :placeholder="$t('track_grid')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('close')}}</button>
      <button
        class="dt-button v1 s6"
        @click.stop="onExport"
        :disabled="this.isFilterEmpty()"
        :class="{
          disabled: this.isFilterEmpty(),
        }"
        :title="this.isFilterEmpty() ? filterEmptyError() : ''"
      >
        {{$t('export')}}
      </button>
      <button
        class="dt-button v1 s6"
        @click.stop="onSearch"
        :disabled="this.isFilterEmpty()"
        :class="{
          disabled: this.isFilterEmpty(),
        }"
        :title="this.isFilterEmpty() ? filterEmptyError() : ''"
      >
        {{$t('search')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import FileDownload from "js-file-download";
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { ProductGroupsService } from "../../services/product-groups.service";
import { async } from "rxjs/internal/scheduler/async";
import { TracksService } from "../../services/tracks.service";
import { createTV } from "../../../../models/text-value.model";
import { addRemoveSet, subscribeSubject } from "../../../../utility";
import {
  ensureBoolIntObjectFromKeys,
  ensureStringObject,
  ensureStringObjectFromKeys,
  keyValuesToObj,
} from "../../../../utility/fp";
import { Subject } from "rxjs";
import { createAdvancedSearchModal } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";

export const trackListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "artist",
    "title",
    "version",
    "track_type",
    "digital_right",
    "genres",
    "licence_account",
    "main_label",
    "any_label",
    "royalty_account",
    "composer",
    "writer",
    "publisher",
    "producer",
    "arranger",
    "royalty_period",
    "invoice_project",
    "metadata_field1",
    "metadata_value1",
    "metadata_field2",
    "metadata_value2",
    "metadata_field3",
    "metadata_value3",
    "income_start",
    "income_end",
    "track_grid",
  ],
  searchConfigIntKeys: [
    "composer_missing",
    "writer_missing",
    "publisher_missing",
    "producer_missing",
    "arranger_missing",
  ],
  booleanSearchKeyLabelMap: {
    isrc_error: "ISRC Error",
    missing_main_product: "Missing Main Product",
    product_track_mismatch: "Product Track Mismatch",
    no_contract: "No Contract",
    playtime_missing: "Playtime is missing",
  },

  searchConfigTVMap: [
    ["track_type", "tracksTypeTV"],
    ["digital_right", "digitalRightTpyesTV"],
    ["licence_account", "licensorsTV"],
    ["main_label", "labelsTV"],
    ["any_label", "labelsTV"],
    ["royalty_period", "royaltyPeriodsTV"],
    ["invoice_project", "royaltyInvoiceProjectTV"],
    ["royalty_account", "royaltyAccountsTV"],
    ["metadata_field1", "metaDataTV"],
    ["metadata_field2", "metaDataTV"],
    ["metadata_field3", "metaDataTV"],
  ],
  searchConfigMulTVMap: [["genres", "genresTV"]],
  searchConfigOmitKeyMap: [
    ["composer", "composer_missing"],
    ["writer", "writer_missing"],
    ["publisher", "publisher_missing"],
    ["producer", "producer_missing"],
    ["arranger", "arranger_missing"],
  ],
});

export default {
  components: {
    Modal,
    TextField,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      artist: "",
      title: "",
      version: "",
      track_type: "",
      digital_right: "",
      genres: "",
      isrc_error: false,
      missing_main_product: false,
      product_track_mismatch: false,
      licence_account: "",
      main_label: "",
      any_label: "",
      royalty_account: "",
      no_contract: false,
      playtime_missing: false,
      composer_missing: "",
      composer: "",
      writer_missing: "",
      writer: "",
      publisher_missing: "",
      publisher: "",
      producer_missing: "",
      producer: "",
      arranger_missing: "",
      arranger: "",
      royalty_period: "",
      invoice_project: "",
      metadata_field1: "",
      metadata_value1: "",
      metadata_field2: "",
      metadata_value2: "",
      metadata_field3: "",
      metadata_value3: "",
      income_start: "",
      income_end: "",
      track_grid: "",

      loading: false,
    };
  },
  mixins: [createAdvancedSearchModal(trackListAdvancedSearchConfig)],
  computed: {
    searchFilter: function () {
      return {
        ...ensureStringObjectFromKeys(
          this,
          trackListAdvancedSearchConfig.searchConfigStringKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          trackListAdvancedSearchConfig.booleanSearchKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          trackListAdvancedSearchConfig.searchConfigIntKeys
        ),
      };
    },
  },
  methods: {
    onDateChange: function (name, value) {
      this[name] = value;
    },
    onTextFieldValueChange: function (name, value) {
      this[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },
    onGenreSelected: function (value) {
      this.genres = value?.map((e) => e.value).join(",");
    },
    onCheckboxChange: function (name, event) {
      this[name] = event.target.checked;
    },
    onSearch: async function () {
      if (this.isFilterEmpty()) {
        return;
      }
      // console.log({ "this.searchFilter": this.searchFilter });
      this.$emit("search", this.searchFilter);
    },
    onExport: async function () {
     const res=await TracksService.exportAdvancedSearch(this.searchFilter);
     console.log('res.data',res.data);
     FileDownload(res.data, "Track_Export.xlsx");
      this.onCancel();
    },
    onSearchOmittedToggle: function (name) {
      if (this[`${name}_missing`] == 1) {
        this[`${name}_missing`] = "0";
      } else {
        this[`${name}_missing`] = `1`;
      }
    },
    isOmitted(name) {
      return this[`${name}_missing`] == `1`;
    },
    filterEmptyError() {
      return `Please provide value to any one of these Fields - Artist, Title, Version, Track type, Digital right, Genres, Isrc error, Missing main product, Product track mismatch, Licence account, Main label, Any label, Royalty account, No contract, Playtime missing, Composer missing, Composer, Writer missing, Writer, Publisher missing, Publisher, Producer missing, Producer, Arranger missing, Arranger, Metadata value1, Metadata value2, Metadata value3, Track grid`;
    },
    isFilterEmpty() {
      let {
        artist,
        title,
        version,
        track_type,
        digital_right,
        genres,
        isrc_error,
        missing_main_product,
        product_track_mismatch,
        licence_account,
        main_label,
        any_label,
        royalty_account,
        no_contract,
        playtime_missing,
        composer_missing,
        composer,
        writer_missing,
        writer,
        publisher_missing,
        publisher,
        producer_missing,
        producer,
        arranger_missing,
        arranger,
        metadata_field1,
        metadata_value1,
        metadata_field2,
        metadata_value2,
        metadata_field3,
        metadata_value3,
        track_grid,
      } = this;

      if (metadata_field1 && metadata_value1) {
        return false;
      }

      if (metadata_field2 && metadata_value2) {
        return false;
      }

      if (metadata_field3 && metadata_value3) {
        return false;
      }

      if (
        !artist &&
        !title &&
        !version &&
        !track_type &&
        !digital_right &&
        !genres?.length &&
        !isrc_error &&
        !missing_main_product &&
        !product_track_mismatch &&
        !licence_account &&
        !main_label &&
        !any_label &&
        !royalty_account &&
        !no_contract &&
        !playtime_missing &&
        !composer_missing &&
        !composer &&
        !writer_missing &&
        !writer &&
        !publisher_missing &&
        !publisher &&
        !producer_missing &&
        !producer &&
        !arranger_missing &&
        !arranger &&
        !track_grid
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-catalog-tracks-advanced_search {
  .body-container {
    max-height: 470px;
    padding-right: 15px;
    overflow: hidden;
    overflow-y: auto;

    .dropdown,
    .dt-input-box--container,
    .date-control {
      max-width: 358px;
    }
  }
  .omit-toggler {
    display: flex;
    cursor: pointer;

    &.missed {
      color: var(--c-error);
    }

    .omit-toggler--label {
      margin: auto 0px auto 4px;
      cursor: pointer;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }

  .checkbox-container {
    .dt-checkbox-control {
      align-items: center;
      height: 30px;
      .dt-checkbox-label {
        flex: 1;
        padding-left: 10px;
      }
    }
  }

  .row-control {
    margin: 10px 0;
    .search--input {
      max-width: 100%;
    }
  }
  .date-control {
    .dt-input-box--container {
      flex: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
}
</style>